<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header [titlePath]="['Gestion des demandes de versement']"
                                 [iconRacine]="'apps'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-subtitle>Modifier et gérer les demandes de versement</mat-card-subtitle>
    <mat-card-content fxLayout="column">
      <div fxLayout="row">
        <p>Afficher les demandes de versements en cours de traitement&nbsp;</p>
        <mat-slide-toggle [checked]="storedFilters?.manager_archived" (change)="toggleArchived($event.checked)"> archivées</mat-slide-toggle>
      </div>
      <div fxLayout="row">
        <p>Afficher les demandes en brouillon non envoyées : non&nbsp;</p>
        <mat-slide-toggle [checked]="storedFilters?.manager_user_draft" (change)="toggleDraft($event.checked)"> oui</mat-slide-toggle>
      </div>
      <div class="manage_deposit">
        <app-data-table
          [borderHeader]="true"
          [colorHeader]="'#fff'"
          [colorHeaderBackground]="'#212529'"
          [actions]="actions"
          [columns]="columns"
          [dataSource]="dsDeposits"
          [extraParams]="extraParams"
          [filterDisplay]="true"
          [flexAction]="5"
          [flexColumn]="90"
          [fontSizeCell]="'0.9em'"
          [minFilter]="1" [pageSize]="10"
          [pageSizesList]="[5,10,25]" [placeHolderFilter]="'Rechercher des versements : nom ou prénom ou N° versement'"
          [refreshButton]="true"
          [refreshIcone]="false"
          [showFirstLastButtons]="true"
          [showLoader]="true"
          [loaderMask]="true"
          [toolTipFilter]="'Recherche de versements : nom ou prénom ou N° versement'"
          [filtersLegend]="true">
        </app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</p8-layout-settings-page>
